import { z } from "zod";
import { MAX_EXPRESSION_LENGTH } from "@globals/rules";

export const ruleConditionSchema = z.object({
  condition: z.string().min(1, "Podmínka nesmí být prázdná").max(MAX_EXPRESSION_LENGTH),
});

export const ruleSchema = z.object({
  id: z.number().int(),
  name: z.string().min(1, "Vyplň název pravidla").max(255),
  notificationTitle: z.string().min(1, "Vyplň nadpis oznámení").max(255),
  notificationBody: z.string().min(1, "Vyplň popisek oznámení").max(1000),
  severity: z.enum(["INFO", "WARNING", "SERIOUS"]),
  conditions: z.array(ruleConditionSchema).min(1, "Pravidlo musí mít alespoň jednu podmínku"),
});

export type RuleFormValues = z.infer<typeof ruleSchema>;
